<template>
    <section>
        <v-container class="nav">
            <v-btn
                icon
                class="black--text"
                @click="$router.go(-1)"
            >
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiCashMultiple }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Excess Hospital Bills
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- End App Bar -->
        <v-container style="width:90%; margin:auto">
            <div v-if="getAREHB">
                <div v-if="getAREHB.info.TAR > 0">
                    <v-data-table
                        :headers="headers"
                        :items="getData"
                        :items-per-page="5"
                        no-data-text
                        :footer-props="footer_props"
                        class="my-10 elevation-10"
                        :hide-headers="screen_width < 600"
                    >
                        <template #item="{ item }">
                            <tr v-if="screen_width < 600">
                                <td colspan="7">
                                    <ul class="flex-content">
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>Debit Memo #.:</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.DMNO_N }}
                                            </li>
                                        </div>
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>Date:</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.DMDA_D }}
                                            </li>
                                        </div>
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>EHB:</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.DUEH_A }}
                                            </li>
                                        </div>
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>PH:</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.DUME_A }}
                                            </li>
                                        </div>
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>EHB(PAID):</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.PAEH_A }}
                                            </li>
                                        </div>
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>PH(PAID):</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.PAME_A }}
                                            </li>
                                        </div>
                                        <div class="content d-flex justify-space-between" style="width:100%">
                                            <label>Remarks:</label>
                                            <li class="flex-item" data-label="Calories">
                                                {{ item.REMA_M }}
                                            </li>
                                        </div>
                                    </ul>
                                </td>
                            </tr>
                            <tr v-else>
                                <td v-text="item.DMNO_N"></td>
                                <td v-text="item.DMDA_D"></td>
                                <td v-text="item.DUEH_A"></td>
                                <td v-text="item.DUME_A"></td>
                                <td v-text="item.PAEH_A"></td>
                                <td v-text="item.PAME_A"></td>
                                <td v-text="item.REMA_M"></td>
                            </tr>
                        </template>
                        <!--
                    <template slot="item" slot-scope="props">
                        <tr>
                        <td v-text="props.item.DMNO_N" />
                        <td v-text="props.item.DMDA_D" />
                        <td v-text="props.item.DUEH_A" />
                        <td v-text="props.item.DUME_A" />
                        <td v-text="props.item.PAEH_A" />
                        <td v-text="props.item.PAME_A" />
                        <td v-text="props.item.REMA_M" />
                        </tr>
                    </template>
                    -->
                    </v-data-table>
                    Outstanding Balance as of {{ moment().utcOffset('+0800').format("DD MMMM YYYY") }} <br>
                    <br>
                    <v-divider />
                    <br>
                    <div class="row">
                        <div class="col d-flex">
                            Excess Hospital Bills:
                        </div>
                        <div class="col d-flex">
                            PHP {{ (getAREHB.info.TEHB) ? (getAREHB.info.TEHB).toFixed(2) : '0.00' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col d-flex">
                            PhilHealth:
                        </div>
                        <div class="col d-flex">
                            PHP {{ (getAREHB.info.TPH) ? (getAREHB.info.TPH).toFixed(2) : '0.00' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col d-flex">
                            Total:
                        </div>
                        <div class="col d-flex">
                            PHP {{ (getAREHB.info.TAR) ? (getAREHB.info.TAR).toFixed(2) : '0.00' }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col d-flex">
                            Interest:
                        </div>
                        <div class="col d-flex">
                            PHP {{ (getAREHB.info.TINT) ? (getAREHB.info.TINT).toFixed(2) : '0.00' }}
                        </div>
                    </div>
                    <br>
                    <v-divider />
                    <br>
                    For more information, please contact HMI.
                </div>
                <div v-else>
                    As of {{ moment().utcOffset('+0800').format("DD MMMM YYYY") }}, you have no excess hospital bills to pay to HMI. Thank you!
                </div>
                <br>
                <div style="background-color: white; padding: 3px; border-radius: 5px;">
                    <v-alert
                        color="teal darken-3"
                        outlined
                        style="margin: 0;"
                        type="info"
                    >
                        <span>Note: The information reported on this page is not displayed in real time, and still subject to succeeding updates.</span>
                    </v-alert>
                </div>
                <br>
            </div>
        </v-container>
    </section>
</template>

<script>
import { mdiArrowLeft, mdiCashMultiple } from '@mdi/js'
import { moment } from '../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
export default {
    data: () => {
        return({
            mdiArrowLeft, mdiCashMultiple,
            screen_width: document.documentElement.clientWidth + 9,
            AR: null,
            footer_props: {
                'items-per-page-options': []
            },
            headers: [
                {
                    text: 'Debit Memo No.',
                    align: 'left',
                    value: 'DMNO_N',
                    class: 'teal--text'
                },
                {
                    text: 'Date',
                    align: 'left',
                    value: 'DMDA_D',
                    class: 'teal--text'
                },
                {
                    text: 'EHB',
                    align: 'left',
                    value: 'DUEH_A',
                    class: 'teal--text'
                },
                {
                    text: 'PH',
                    align: 'left',
                    value: 'DUME_A',
                    class: 'teal--text'
                },
                {
                    text: 'PAID EHB',
                    align: 'left',
                    value: 'PAEH_A',
                    class: 'teal--text'
                },
                {
                    text: 'PAID PH',
                    align: 'left',
                    value: 'PAME_A',
                    class: 'teal--text'
                },
                {
                    text: 'Remarks',
                    align: 'left',
                    value: 'REMA_M',
                    class: 'teal--text'
                }
            ]
        })
    },
    computed: {
        ...mapGetters(['getAREHB']),
        getData: {
            get(){
                let row = this.getAREHB.info.ROW
                let data = []
                if (row) {
                    for (var i = 0; i < row.length; i++) {
                        data.push({
                            DMNO_N: row[i].DMNO_N,
                            DMDA_D: moment(row[i].DMDA_D).utcOffset('+0800').format('DD MMM YY'),
                            DUEH_A: `PHP ${(row[i].DUEH_A) ? (row[i].DUEH_A).toFixed(2) : '0.00'}`,
                            DUME_A: `PHP ${(row[i].DUME_A) ? (row[i].DUME_A).toFixed(2) : '0.00'}`,
                            PAEH_A: `PHP ${(row[i].PAEH_A) ? (row[i].PAEH_A).toFixed(2) : '0.00'}`,
                            PAME_A: `PHP ${(row[i].PAME_A) ? (row[i].PAME_A).toFixed(2) : '0.00'}`,
                            REMA_M: row[i].REMA_M
                        })
                    }
                }
                return data
            }
        }
    },
    async mounted () {
        window.addEventListener('resize', this.onResize)
        this.displayAREHB({ MEMBN: this.$cookies.get('usermembn') })
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['displayAREHB', 'getCsrfToken']),
        print(param) {
            // console.log(param);
            return param
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 8
            // console.log(this.screen_width);
        }
    }
}
</script>

<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

.flex-content {
    padding: 0;
    margin: 10px auto;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.flex-item {
    padding: 5px;
    width: 100%;
    height: 40px;
    text-align: right;
}

@media (max-width: 390px) {
    .page-icon {
        display: none;
    }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
